import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  // Input, // 已注释，仅保留查看功能
  Button,
  Table,
  // Modal, // 已注释，仅保留查看功能
  Space,
  message,
  // Row, // 已注释，仅保留查看功能
  // Col, // 已注释，仅保留查看功能
  Select,
  Tag,
  // DatePicker, // 已注释，仅保留查看功能
  InputNumber,
} from "antd";
import {
  // PlusOutlined, // 已注释，仅保留查看功能
  // EditOutlined, // 已注释，仅保留查看功能
  SearchOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { VipService } from "../../services";
// import { UserService } from "../../services"; // 已注释，仅保留查看功能
import {
  VipMember,
  // CreateVipDto, // 已注释，仅保留查看功能
  // UpdateVipDto, // 已注释，仅保留查看功能
  VipQueryParams,
  VipLevel,
  VipStatus,
  VipLevelOption,
  VipStatusOption,
} from "../../types/vip";
// import { User } from "../../types"; // 已注释，仅保留查看功能
import ErrorHandler from "../../utils/errorHandler";
import MainLayout from "../../components/layout/MainLayout";
import dayjs from "dayjs";
import "./VipManagement.scss";

const { Option } = Select;

const VipManagementPage: React.FC = () => {
  const [vipMembers, setVipMembers] = useState<VipMember[]>([]);
  const [loading, setLoading] = useState(false);
  // const [modalVisible, setModalVisible] = useState(false); // 已注释，仅保留查看功能
  // const [editingVip, setEditingVip] = useState<VipMember | null>(null); // 已注释，仅保留查看功能
  const [searchParams, setSearchParams] = useState<VipQueryParams>({});
  const [pagination, setPagination] = useState({
    current: 1,
    limit: 10,
    total: 0,
  });
  // const [vipForm] = Form.useForm(); // 已注释，仅保留查看功能
  const [searchForm] = Form.useForm();

  // 枚举值
  const [levelOptions, setLevelOptions] = useState<VipLevelOption[]>([]);
  const [statusOptions, setStatusOptions] = useState<VipStatusOption[]>([]);
  // const [users, setUsers] = useState<User[]>([]); // 已注释，仅保留查看功能

  // 加载枚举值
  const loadEnums = async () => {
    try {
      const response = await VipService.getVipEnums();
      if (response.code === 0 && response.data) {
        setLevelOptions(response.data.levels || []);
        setStatusOptions(response.data.statuses || []);
      }
    } catch (error) {
      ErrorHandler.handleApiError(error);
    }
  };

  // 加载用户列表（用于选择用户）- 已注释，仅保留查看功能
  // const loadUsers = async () => {
  //   try {
  //     const response = await UserService.getUserList({ limit: 1000 });
  //     if (response.code === 0 && response.data) {
  //       const userList = response.data.list || [];
  //       setUsers(userList);
  //       console.log("加载用户列表成功，数量:", userList.length);
  //     } else {
  //       console.error("加载用户列表失败:", response.msg);
  //     }
  //   } catch (error) {
  //     console.error("加载用户列表异常:", error);
  //     ErrorHandler.handleApiError(error);
  //   }
  // };

  // 加载 VIP 会员列表
  const loadVipMembers = async (params?: VipQueryParams) => {
    setLoading(true);
    try {
      const queryParams = {
        ...searchParams,
        ...params,
        // 优先使用传入的 params 中的 page 和 limit，否则使用状态中的值
        page: params?.page ?? pagination.current,
        limit: params?.limit ?? pagination.limit,
      };

      const response = await VipService.getVipList(queryParams);

      if (response.code === 0 && response.data) {
        const data = response.data;
        setVipMembers(data.data || []);
        setPagination((prev) => ({
          ...prev,
          current: data.page || 1,
          total: data.total || 0,
          limit: data.limit || prev.limit,
        }));
      } else {
        message.error(response.msg || "获取VIP会员列表失败");
      }
    } catch (error) {
      ErrorHandler.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  // 使用独立参数加载，避免状态合并问题
  const loadVipMembersWithParams = async (params: any) => {
    setLoading(true);
    try {
      const response = await VipService.getVipList(params);

      if (response.code === 0 && response.data) {
        const data = response.data;
        setVipMembers(data.data || []);
        setPagination((prev) => ({
          ...prev,
          current: data.page || 1,
          total: data.total || 0,
          limit: data.limit || prev.limit,
        }));
      } else {
        message.error(response.msg || "获取VIP会员列表失败");
      }
    } catch (error) {
      ErrorHandler.handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  // 初始化加载
  useEffect(() => {
    loadEnums();
    // loadUsers(); // 已注释，仅保留查看功能
    loadVipMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 保存 VIP 会员 - 已注释，仅保留查看功能
  // const handleSaveVip = async (values: CreateVipDto | UpdateVipDto) => {
  //   try {
  //     setLoading(true);
  //     let response;

  //     // 处理过期时间
  //     const submitValues: any = { ...values };
  //     if (submitValues.expireAt && dayjs.isDayjs(submitValues.expireAt)) {
  //       submitValues.expireAt = submitValues.expireAt.toISOString();
  //     }

  //     if (editingVip) {
  //       // 更新
  //       response = await VipService.updateVip(
  //         editingVip.id,
  //         submitValues as UpdateVipDto
  //       );
  //     } else {
  //       // 创建
  //       response = await VipService.createVip(submitValues as CreateVipDto);
  //     }

  //     if (response.code === 0) {
  //       message.success(`${editingVip ? "更新" : "创建"}VIP会员成功`);
  //       handleCloseModal();
  //       loadVipMembers();
  //     } else {
  //       message.error(response.msg || "操作失败");
  //     }
  //   } catch (error) {
  //     ErrorHandler.handleApiError(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // 打开 VIP 弹窗 - 已注释，仅保留查看功能
  // const handleOpenModal = (vip?: VipMember) => {
  //   setEditingVip(vip || null);
  //   vipForm.resetFields();
  //   setModalVisible(true);

  //   // 如果是编辑模式，在下一个事件循环中设置值
  //   if (vip) {
  //     setTimeout(() => {
  //       vipForm.setFieldsValue({
  //         ...vip,
  //         expireAt: vip.expireAt ? dayjs(vip.expireAt) : null,
  //       });
  //     }, 0);
  //   } else {
  //     // 新建时设置默认值
  //     vipForm.setFieldsValue({
  //       status: 1,
  //     });
  //   }
  // };

  // 关闭 VIP 弹窗 - 已注释，仅保留查看功能
  // const handleCloseModal = () => {
  //   setModalVisible(false);
  //   setEditingVip(null);
  //   vipForm.resetFields();
  // };

  // 搜索 VIP 会员
  const handleSearch = async (values: VipQueryParams) => {
    const params = {
      ...values,
      page: 1, // 搜索时重置到第一页
    };
    setSearchParams(params);
    setPagination((prev) => ({ ...prev, current: 1 }));
    await loadVipMembers(params);
  };

  // 重置搜索
  const handleReset = () => {
    searchForm.resetFields();
    const resetParams = {};
    setSearchParams(resetParams);
    setPagination((prev) => ({ ...prev, current: 1 }));
    loadVipMembersWithParams({ page: 1, limit: pagination.limit });
  };

  // 获取等级名称
  const getLevelName = (level: VipLevel) => {
    const levelOption = levelOptions.find((opt) => opt.level === level);
    return levelOption ? levelOption.name : `等级${level}`;
  };

  // 渲染状态标签
  const renderStatus = (status: VipStatus) => {
    const statusMap: Record<VipStatus, { text: string; color: string }> = {
      0: { text: "未激活", color: "default" },
      1: { text: "已激活", color: "green" },
      2: { text: "已过期", color: "red" },
      3: { text: "作废", color: "orange" },
    };

    const config = statusMap[status] || {
      text: `状态${status}`,
      color: "default",
    };
    return <Tag color={config.color}>{config.text}</Tag>;
  };

  // VIP 会员表格列
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
      fixed: "left" as const,
    },
    {
      title: "会员等级",
      dataIndex: "level",
      key: "level",
      width: 90,
      render: (level: VipLevel) => (
        <Tag color="gold">{getLevelName(level)}</Tag>
      ),
    },
    {
      title: "用户ID",
      dataIndex: "accountId",
      key: "accountId",
      width: 80,
    },
    {
      title: "充值总算力",
      dataIndex: "rechargeTotal",
      key: "rechargeTotal",
      width: 120,
      render: (amount: number | string | undefined) => {
        if (amount === undefined || amount === null || amount === "") {
          return "-";
        }
        const numAmount =
          typeof amount === "string" ? parseFloat(amount) : Number(amount);
        if (isNaN(numAmount)) {
          return "-";
        }
        return `${numAmount.toFixed(2)}`;
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      width: 90,
      render: renderStatus,
    },
    {
      title: "描述",
      dataIndex: "description",
      key: "description",
      width: 150,
      ellipsis: true,
      render: (text: string) => text || "-",
    },
    {
      title: "创建时间",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 160,
      render: (time: string) =>
        time ? dayjs(time).format("YYYY-MM-DD HH:mm") : "-",
    },
    // {
    //   title: "操作",
    //   key: "action",
    //   width: 100,
    //   fixed: "right" as const,
    //   render: (_: any, record: VipMember) => (
    //     <Space size="small">
    //       <Button
    //         type="link"
    //         size="small"
    //         icon={<EditOutlined />}
    //         onClick={() => handleOpenModal(record)}
    //       >
    //         编辑
    //       </Button>
    //     </Space>
    //   ),
    // },
  ];

  return (
    <MainLayout title="VIP会员管理">
      <div className="vip-management">
        {/* 搜索区域 */}
        <Card className="search-card" style={{ marginBottom: 16 }}>
          <Form form={searchForm} layout="inline" onFinish={handleSearch}>
            <Form.Item name="level" label="会员等级">
              <Select
                placeholder="请选择等级"
                style={{ width: 150 }}
                allowClear
              >
                {levelOptions.map((option) => (
                  <Option key={option.level} value={option.level}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="status" label="状态">
              <Select
                placeholder="请选择状态"
                style={{ width: 150 }}
                allowClear
              >
                {statusOptions.map((option) => (
                  <Option key={option.status} value={option.status}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="accountId" label="用户ID">
              <InputNumber
                placeholder="请输入用户ID"
                style={{ width: 150 }}
                min={1}
                precision={0}
              />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SearchOutlined />}
                >
                  搜索
                </Button>
                <Button onClick={handleReset} icon={<ReloadOutlined />}>
                  重置
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>

        {/* VIP 会员列表 */}
        <Card title="VIP会员列表">
          {/* extra={
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
            >
              新增VIP会员
            </Button>
          } */}
          <Table
            columns={columns}
            dataSource={vipMembers}
            rowKey="id"
            loading={loading}
            scroll={{ x: 1200 }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.limit,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
              onChange: (page, pageSize) => {
                const newLimit = pageSize || pagination.limit;
                // 判断是否是改变每页数量（pageSize 变化且不是第一页）
                const isSizeChange = pageSize !== pagination.limit;
                const targetPage = isSizeChange ? 1 : page; // 改变每页数量时重置到第一页

                setPagination((prev) => ({
                  ...prev,
                  current: targetPage,
                  limit: newLimit,
                }));

                // 使用独立函数，确保使用最新的参数
                loadVipMembersWithParams({
                  ...searchParams,
                  page: targetPage,
                  limit: newLimit,
                });
              },
            }}
          />
        </Card>

        {/* VIP 弹窗 - 已注释，仅保留查看功能 */}
        {/* <Modal
          title={`${editingVip ? "编辑" : "新增"}VIP会员`}
          open={modalVisible}
          onOk={() => vipForm.submit()}
          onCancel={handleCloseModal}
          confirmLoading={loading}
          width={600}
        >
          <Form form={vipForm} layout="vertical" onFinish={handleSaveVip}>
            {!editingVip && (
              <Form.Item
                name="accountId"
                label="关联用户"
                rules={[{ required: true, message: "请选择用户" }]}
              >
                <Select
                  placeholder="请选择用户"
                  showSearch
                  filterOption={(input, option) => {
                    const label = String(option?.children || "");
                    return label.toLowerCase().includes(input.toLowerCase());
                  }}
                >
                  {users.map((user) => (
                    <Option key={user.id} value={user.id}>
                      {user.username || user.phone} ({user.id})
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="level"
                  label="会员等级"
                  rules={[{ required: true, message: "请选择会员等级" }]}
                >
                  <Select placeholder="请选择会员等级">
                    {levelOptions.map((option) => (
                      <Option key={option.level} value={option.level}>
                        {option.name} (等级{option.level})
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="expireAt"
                  label="过期时间"
                  rules={[{ required: true, message: "请选择过期时间" }]}
                >
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    style={{ width: "100%" }}
                    placeholder="请选择过期时间"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="status" label="状态">
                  <Select placeholder="请选择状态" defaultValue={1}>
                    {statusOptions.map((option) => (
                      <Option key={option.status} value={option.status}>
                        {option.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item name="description" label="会员描述">
              <Input.TextArea
                placeholder="请输入会员描述（可选）"
                rows={3}
                maxLength={500}
                showCount
              />
            </Form.Item>
          </Form>
        </Modal> */}
      </div>
    </MainLayout>
  );
};

export default VipManagementPage;
